<template>
  <DropDownSelect>
    <template #value>
      <div class="drop-down-value">
        {{ $t(`kano.price-chart.time-period-select.${value}`) }}
      </div>
    </template>
    <template #default="{hide}">
      <div v-for="period in timePeriods"
         :key="period"
         class="drop-down-item"
         :class="{ 'is-selected': period === value}"
         @click="selectPeriod(period); hide()"
      >
        {{ $t(`kano.price-chart.time-period-select.${period}`) }}
      </div>
    </template>
  </DropDownSelect>
</template>

<script setup lang="ts">
import DropDownSelect from "@kano/components/CryptoPriceChart/Chart/DropDownSelect.vue";
import { ChartTimePeriod } from "@kano/types/crypto-price-chart";

const props = defineProps<{
  value: ChartTimePeriod,
}>();

const emit = defineEmits<{
  (event: 'input', value: ChartTimePeriod): void,
}>();

const timePeriods = Object.values(ChartTimePeriod);

const selectPeriod = (period: ChartTimePeriod) => {
  emit("input", period);
}
</script>

<style scoped lang="scss">
.drop-down-value {
  min-width: 85px;
}

.drop-down-item {
  font-family: Inter Tight, Inter Tight fallback, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 8px;
  

  &:hover {
    cursor: pointer;
    color: var(--color-base-48);
  }
}

.is-selected {
  color: var(--color-primary);
}
</style>